import { gql } from '@apollo/client';

const updateTax = gql`
  mutation ($variables: TaxInput!, $id: Int!) {
    updateTax(input: $variables, id: $id)
  }
`;
export default updateTax;
